module.exports = __webpack_public_path__ + "static/media/long-27.b55112cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/long/long-27.png
// module id = 2151
// module chunks = 0